export default {
  pageNotFound: {
    text1: '¡No encontramos la página que Ud. está buscando',
    link: 'Vuelva a la página inicial',
    text2: 'o vea nuestros contenidos ↓',
  },
}
